
import React from 'react';
import { Upload, FileText, CheckCircle } from 'lucide-react';

interface ProcessingPipelineProps {
    processingStage: number;
}

const ProcessingPipeline: React.FC<ProcessingPipelineProps> = ({ processingStage }) => {
    const stages = [
        {
            title: 'Reading & Preparing Documents',
            description: 'Converting files for AI analysis',
            Icon: Upload,
            stage: 1,
            color: 'teal'
        },
        {
            title: 'AI Data Extraction',
            description: 'Model is identifying key fields and values',
            Icon: FileText,
            stage: 2,
            color: 'blue'
        },
        {
            title: 'Finalizing & Validating Data',
            description: 'Structuring data for your review',
            Icon: CheckCircle,
            stage: 3,
            color: 'emerald'
        }
    ];

    const stageColors = {
        teal: {
            bg: 'bg-teal-900/50',
            iconBg: 'bg-teal-800/50',
            iconText: 'text-teal-400',
        },
        blue: {
            bg: 'bg-blue-900/50',
            iconBg: 'bg-blue-800/50',
            iconText: 'text-blue-400',
        },
        emerald: {
            bg: 'bg-emerald-900/50',
            iconBg: 'bg-emerald-800/50',
            iconText: 'text-emerald-400',
        }
    };

    return (
        <div className="glass-card rounded-xl p-6 animate-slideUp">
            <h3 className="text-xl font-bold text-white mb-6">Processing Pipeline</h3>
            <div className="space-y-4">
                {stages.map((s) => {
                    const colors = stageColors[s.color as keyof typeof stageColors];
                    return (
                        <div key={s.stage} className={`flex items-center gap-4 p-4 rounded-lg ${processingStage >= s.stage ? colors.bg : 'bg-gray-800'}`}>
                            <div className={`p-2 rounded-lg ${processingStage >= s.stage ? colors.iconBg : 'bg-gray-700'}`}>
                                {processingStage > s.stage ? (
                                    <CheckCircle className={colors.iconText} size={24} />
                                ) : (
                                    <div className={processingStage === s.stage ? 'animate-pulse-strong' : ''}>
                                        <s.Icon className={processingStage >= s.stage ? colors.iconText : 'text-gray-500'} size={24} />
                                    </div>
                                )}
                            </div>
                            <div>
                                <p className="font-semibold text-white">{s.title}</p>
                                <p className="text-sm text-gray-400">{s.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ProcessingPipeline;